<template>
  <section>
    <loading-flux :value="loadingClose"> </loading-flux>
    <v-alert
      border="left"
      color="blue light"
      text
      type="info"
      v-if="cubageMaterials.length && someCubageMaterialWithoutType"
    >
      Cubicación cerrada. Los materiales fueron cargados manualmente desde
      abastecimiento
    </v-alert>
    <v-alert
      v-if="latestCubageBundle"
      border="left"
      :type="bundleAlertType"
      text
    >
      <div class="d-flex align-center flex-wrap">
        <span>
          Solicitud de llenado inicial
          <b>{{ getSliCode(latestCubageBundle) }}</b>:
          <v-chip :color="bundleStatusInfo.color" class="text-white ml-2" small>
            {{ bundleStatusInfo.name }}
          </v-chip>
          <span v-if="latestCubageBundle.total_amount" class="ml-2">
            Monto: $ {{ latestCubageBundle.total_amount.toLocaleString("es", optionsAmountFormatting) }}
          </span>
          <span v-if="latestCubageBundle.sap_code" class="ml-2">
            Código SAP: {{ latestCubageBundle.sap_code }}
          </span>
          <span v-if="latestCubageBundle.desired_dispatch_date" class="ml-2">
            Despacho deseado: {{ latestCubageBundle.desired_dispatch_date.split("-").reverse().join("/") }}
          </span>
          <v-chip
            v-if="cubageClosure && cubageClosure.closes_at"
            small
            class="ml-2 text-white"
            :color="cubageClosure.closed ? 'grey darken-2' : 'orange darken-2'"
          >
            {{
              cubageClosure.closed
                ? `Cubicación cerrada desde el ${formatDateTime(cubageClosure.closes_at)}`
                : `Se cierra el ${formatDateTime(cubageClosure.closes_at)} (${cubageClosure.close_days_after_dispatch} días después del despacho)`
            }}
          </v-chip>
        </span>
        <v-btn
          outlined
          small
          dark
          color="grey darken-3"
          class="ml-auto"
          :loading="loadingBundleStatus"
          @click="refreshCubageBundles"
        >
          Actualizar estado
        </v-btn>
      </div>
      <request-status-detail
        :bundle="latestCubageBundle"
        :materialsInfo="materialsInfo"
      ></request-status-detail>
    </v-alert>
    <cubage-delivery-header
      v-if="unifiedOrder && currentCubage"
      :documentId="currentCubage.id"
      :projectDefaults="projectInfoDetailAndTecnical"
      :disabled="Boolean(currentCubage.isClosed)"
      @change="deliveryInfo = $event"
    ></cubage-delivery-header>
    <cubage-validation-alerts
      v-if="cubicadorV2Enabled && currentCubage && !currentCubage.isClosed"
      :documentId="currentCubage.id"
      :materials="cubageMaterials"
      :desiredDispatchDate="deliveryInfo ? deliveryInfo.desired_dispatch_date : null"
      @substituted="getCubageMaterials({ document_id: currentCubage.id })"
    ></cubage-validation-alerts>
    <v-row>
      <v-col cols="12" md="12" sm="12" class="mb-2">
        <section
          class="text-center d-flex justify-content-center align-items-center"
        >
          <v-tooltip top v-if="currentCubageIsIncomplete">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-large
                outlined
                class="mx-3"
                color="red darken-2 text-white"
                @click="openModalSendCubage(true)"
                v-bind="attrs"
                v-on="on"
              >
                Enviar materiales restantes
              </v-btn>
            </template>
            <span
              >Esta acción envía los materiales restantes a
              {{ $route.query.sap_project ? "SAP" : "Flexline" }}, en caso de
              que haya ocurrido un problema al enviar la solicitud</span
            >
          </v-tooltip>
          <v-tooltip top v-if="!(cubicadorV2Enabled && $route.query.sap_project)">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-large
                outlined
                color="red darken-2 text-white"
                :disabled="
                  loadingClose || (currentCubage && currentCubage.isClosed)
                "
                @click="openModalSendCubage()"
                v-bind="attrs"
                v-on="on"
              >
                Enviar cubicación
              </v-btn>
            </template>
            <span
              >Esta acción ejecuta el cierre y envía la solicitud de llenado
              inicial a
              {{ $route.query.sap_project ? "SAP" : "Flexline" }} contemplando
              todos los items de la cubicación</span
            >
          </v-tooltip>
          <v-tooltip top v-if="cubicadorV2Enabled && $route.query.sap_project">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-large
                outlined
                class="mx-3"
                color="blue darken-2 text-white"
                :disabled="
                  loadingCloseV2 ||
                    (currentCubage && currentCubage.isClosed) ||
                    Boolean(cubageClosure && cubageClosure.closed) ||
                    !deliveryComplete
                "
                @click="openModalSendCubageV2()"
                v-bind="attrs"
                v-on="on"
              >
                Enviar cubicación (con aprobación)
              </v-btn>
            </template>
            <span>{{
              deliveryComplete
                ? "Esta acción reserva y/o compra todos los materiales de la cubicación en una sola solicitud, sujeta a aprobación antes de ser enviada a SAP"
                : "Completa y guarda los datos de despacho para habilitar el envío"
            }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                large
                outlined
                v-if="
                  currentCubage &&
                    cubageMaterialsIsSomeMaterialRemainingToClose &&
                    !someCubageMaterialWithoutType
                "
                class="mx-2"
                color="red darken-2 text-white"
                @click="closeRemainingCurrentCubage(true)"
                v-bind="attrs"
                v-on="on"
              >
                Solicitar materiales restantes
              </v-btn>
            </template>
            <span
              >Esta acción envia la solicitud a flexline de los materiales sin
              código que fueron sustituidos por uno con código de la
              cubicación</span
            >
          </v-tooltip>
        </section>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <v-tooltip
          top
          v-if="cubageMaterials.length && !someCubageMaterialWithoutType"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              color="blue darken-2 text-white"
              :loading="loading"
              :disabled="currentCubage && currentCubage.isClosed"
              class="mb-2 mr-2"
              @click="openModalCreateTemplateFromCubage"
              v-bind="attrs"
              v-on="on"
            >
              Guardar Template
            </v-btn>
          </template>
          <span
            >Esta acción permite crear un nuevo template a partir de esta
            cubicación</span
          >
        </v-tooltip>
        <v-tooltip top v-if="!someCubageMaterialWithoutType">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              class="mr-2 mb-2"
              color="blue darken-2 text-white"
              :loading="loading"
              :disabled="currentCubage && currentCubage.isClosed"
              @click="openModalCopyFromTemplate"
              v-bind="attrs"
              v-on="on"
            >
              Cargar
            </v-btn>
          </template>
          <span
            >Esta acción permite cargar todos los elementos de un template
            previamente creado a esta cubicación</span
          >
        </v-tooltip>
        <v-tooltip top v-if="!someCubageMaterialWithoutType">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              class="mt-lg-0 mx-0 mb-2 mr-sm-2"
              color="blue darken-2 text-white"
              :loading="loading"
              :disabled="currentCubage && currentCubage.isClosed"
              @click="openModalUploadMaterialsExcelFromCubage"
              v-bind="attrs"
              v-on="on"
            >
              Carga masiva de materiales
            </v-btn>
          </template>
          <span
            >Esta acción permite cargar masivamente un listado de materiales a
            esta cubicación mediante un archivo excel con un formato base</span
          >
        </v-tooltip>
        <v-tooltip top v-if="!someCubageMaterialWithoutType">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              color="red darken-2 text-white"
              class="mb-2 mx-sm-0 mx-2"
              :loading="loading || loadingClose"
              :disabled="!canResetCubage"
              v-bind="attrs"
              v-on="on"
              @click="resetCurrentCubage"
            >
              Reiniciar Cubicación
            </v-btn>
          </template>
          <span
            >Esta acción borra todos los materiales de la cubicación, solo se
            puede ejecutar cuando la cubicación no esta cerrada. Si su solicitud ya está
            en SAP, se anula mientras no se haya preparado ni comprado nada</span
          >
        </v-tooltip>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              class="mx-2 float-right"
              color="grey darken-2 text-white"
              @click="showCosts = !showCosts"
              v-bind="attrs"
              v-on="on"
            >
              {{ showCosts ? "Ocultar costos" : "Mostrar costos" }}
              <v-icon small class="pl-2">
                {{
                  showCosts
                    ? "mdi-arrow-collapse-right"
                    : "mdi-arrow-collapse-left"
                }}
              </v-icon>
            </v-btn>
          </template>
          <span
            >Esta acción permite mostrar/ocultar un panel de costos totales de
            la cubicación</span
          >
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              class="float-right"
              color="blue darken-2 text-white"
              @click="openModalShowInitialFillRequests"
              v-bind="attrs"
              v-on="on"
            >
              Ver detalles
            </v-btn>
          </template>

          <span
            >Esta acción permite ver el listado de solicitudes de llenado
            inicial realizadas en esta cubicación</span
          >
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              class="float-right mr-2"
              color="green darken-2"
              :loading="loadingExcel"
              @click="downloadExcelFromCubage"
              v-bind="attrs"
              v-on="on"
            >
              Descargar Excel
            </v-btn>
          </template>

          <span
            >Esta acción permite descargar un archivo excel con el resumen
            detallado de la cubicación</span
          >
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        :md="showCosts ? 10 : 12"
        sm="12"
        class="transition-easy-out"
      >
        <v-tabs v-model="tab" fixed-tabs>
          <v-tab key="principal">
            {{ unifiedOrder ? "Pedido completo (equipos principales + materiales)" : "Equipos Principales" }}
          </v-tab>
          <v-tab v-if="!unifiedOrder" key="materials"> Materiales </v-tab>
          <v-tab key="execution"> Ejecución </v-tab>
          <v-tab key="others"> Otros </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="principal">
            <main-teams></main-teams>
            <!-- v2: one view for the whole initial order, main equipment first -->
            <cubicle-materials v-if="unifiedOrder" class="mt-4"></cubicle-materials>
          </v-tab-item>
          <v-tab-item v-if="!unifiedOrder" key="materials">
            <cubicle-materials></cubicle-materials>
          </v-tab-item>
          <v-tab-item key="execution">
            <execution></execution>
          </v-tab-item>
          <v-tab-item key="others">
            <others-attachments></others-attachments>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col cols="12" md="2" sm="12" class="px-0" v-show="showCosts">
        <total-costs></total-costs>
      </v-col>
    </v-row>
    <!-- Modal para ver solicitudes de llenado inicial de la cubicación -->
    <show-initial-fill-requests
      :modalAction="dialogShowInitialFillRequests"
      :closeModalShowInitialFillRequests="closeModalShowInitialFillRequests"
    ></show-initial-fill-requests>

    <!-- Modal de copiar template -->
    <copy-to-template-cubage
      :modalAction="dialogCopyToTemplate"
      :closeModalCopyToTemplate="closeModalCopyToTemplate"
      @materialsCopied="
        getCubageMaterials({
          document_id: currentCubage.id,
        })
      "
    ></copy-to-template-cubage>
    <!-- Modal de crear template desde una cubicación -->
    <create-template-from-cubage
      :modalAction="dialogCreateTemplateFromCubage"
      :closeModalCreateTemplateFromCubage="closeModalCreateTemplateFromCubage"
      @newTemplateAdded="getTemplates"
    ></create-template-from-cubage>

    <!-- Modal de copiar desde un template -->
    <copy-from-template
      :modalAction="dialogCopyFromTemplate"
      :closeModalCopyFromTemplate="closeModalCopyFromTemplate"
      @templateCopied="
        getCubageMaterials({
          document_id: currentCubage.id,
        })
      "
    ></copy-from-template>
    <!-- Modal Upload Materials From Excel -->
    <upload-materials-excel-from-cubage
      :modalAction="dialogUploadMaterialsExcelFromCubage"
      :closeModalUploadMaterialsExcelFromCubage="
        closeModalUploadMaterialsExcelFromCubage
      "
      @materialsUploaded="
        getCubageMaterials({
          document_id: currentCubage.id,
        })
      "
    ></upload-materials-excel-from-cubage>

    <!-- Modal cerrar cubicación -->
    <v-dialog
      v-model="dialogSendCubage"
      max-width="700px"
      @keydown="closeModalSendCubage"
      @click:outside="closeModalSendCubage"
    >
      <v-card>
        <v-card-title class="p-0">
          <v-toolbar :color="sendCubageMode === 'v2' ? 'blue darken-2' : 'red darken-2'" dark>
            <v-toolbar-title>
              <span class="text-h6">{{ sendCubageMode === 'v2' ? 'Enviar cubicación (con aprobación)' : 'Enviar cubicación' }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <p v-if="sendCubageMode === 'v2'" class="mt-5 font-weight-bold px-1">
            ¿ Deseas enviar esta cubicación a través del flujo con reserva y
            aprobación ? se creará una sola solicitud con todos los materiales
            (reservando stock disponible y comprando el faltante), la cual
            debe ser aprobada antes de ser enviada a SAP. Una vez aprobada, no
            podrá ser editada desde la pantalla de aprobaciones.
          </p>
          <p v-else class="mt-5 font-weight-bold px-1">
            ¿ Deseas cerrar esta cubicación ? una vez cerrada, se envía la
            solicitud de los materiales y solo podras modificar los materiales
            sin código
          </p>
          <section
            v-if="$route.query.sap_project && !currentProjectIsOv"
            class="text-center mt-5 pt-5"
          >
            <label class="">
              Selecciona la etapa del proyecto para la cubicación
            </label>
            <v-autocomplete
              class="w-50 mx-auto"
              placeholder="Etapa del proyecto"
              v-model="form.sap_stage"
              :items="availableStagesProjects"
              item-value="sap_code"
              item-text="name"
            ></v-autocomplete>
          </section>
          <section v-if="sendCubageMode === 'v2'" class="text-center mt-3">
            <label>Fecha de despacho deseada</label>
            <v-text-field
              v-model="form.desired_dispatch_date"
              class="w-50 mx-auto"
              type="date"
              :min="minDispatchDate"
              hint="Mínimo 2 días hábiles desde hoy. El picking parte 2 días hábiles antes de esta fecha y hasta entonces la solicitud se puede editar"
              persistent-hint
            ></v-text-field>
          </section>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            outlined
            :disabled="loadingClose || loadingCloseV2"
            @click="closeModalSendCubage($event)"
          >
            <small> Cancelar </small>
          </v-btn>
          <v-btn
            v-if="sendCubageMode === 'v2'"
            :disabled="loadingCloseV2"
            color="blue darken-3"
            class="text-white"
            @click="closeCurrentCubageV2()"
          >
            <small> Enviar a aprobación </small>
          </v-btn>
          <v-btn
            v-else
            :disabled="loadingClose"
            color="red darken-3"
            class="text-white"
            @click="closeCurrentCubage(false)"
          >
            <small> Cerrar cubicación </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { proyectoMethods, proyectoComputed } from "@/state/helpers";
import { authMethods, authUsuarioComputed } from "@/state/helpers";
import { permiso } from "@/helpers/authservice/obtener-permisos";
import CubicleMaterials from "@/components/proyectos/lugarInstalacion/cubicles/materials/index.vue";
import MainTeams from "@/components/proyectos/lugarInstalacion/cubicles/mainTeams/index.vue";
import Execution from "@/components/proyectos/lugarInstalacion/cubicles/execution/index.vue";
import OthersAttachments from "@/components/proyectos/lugarInstalacion/cubicles/others/Attachments.vue";
import CopyToTemplateCubage from "./materials/CopyToTemplateCubage.vue";
import { mapActions, mapGetters } from "vuex";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import CreateTemplateFromCubage from "./components/CreateTemplateFromCubage.vue";
import CopyFromTemplate from "./components/CopyFromTemplate.vue";
import ShowInitialFillRequests from "./components/ShowInitialFillRequests.vue";
import UploadMaterialsExcelFromCubage from "./components/UploadMaterialsExcelFromCubage.vue";
import TotalCosts from "./components/TotalCosts.vue";
import RequestStatusDetail from "./components/RequestStatusDetail.vue";
import CubageValidationAlerts from "./components/CubageValidationAlerts.vue";
import CubageDeliveryHeader from "./components/CubageDeliveryHeader.vue";
import {
  getSliCode,
  leadTimeWarningHtml,
  minDispatchIsoDate,
  isStandardMaterial,
  MAIN_EQUIPMENT_ITEM_GASTO,
} from "@/helpers/cubage";
import { TYPES_REQUESTS_SAP } from "@/constants/requestMaterial";
import statusAndEtaRequestsMixin from "@/mixins/statusAndEtaRequestsMixin";
import { TYPE_CUBAGE_MAIN_TEAMS } from "@/constants/cubage";
import { extractWordsUpperCase } from "@/helpers/common";
import { DEFAULT_STAGE_PROJECT_OV_RESIDENTIAL, OPTIONS_AMOUNT_FORMATTING } from "@/constants/common";
import { CUBAGE_BUNDLE_STATUS, CUBAGE_BUNDLE_STATUS_LIST } from "@/constants/cubage";
import config from "@/config";
export default {
  mixins: [statusAndEtaRequestsMixin],
  components: {
    CubicleMaterials,
    CopyToTemplateCubage,
    MainTeams,
    Execution,
    OthersAttachments,
    CreateTemplateFromCubage,
    CopyFromTemplate,
    ShowInitialFillRequests,
    UploadMaterialsExcelFromCubage,
    TotalCosts,
    RequestStatusDetail,
    CubageValidationAlerts,
    CubageDeliveryHeader,
  },
  async mounted() {
    this.getAllData();
  },
  destroyed() {
    this.setDefaultCurrentCubage();
    this.setDefaultCubageMaterials();
    this.cleanInitialFillRequests();
    this.resetCurrentSapCodes();
  },
  data() {
    return {
      tab: "materials",
      loading: false,
      loadingClose: false,
      loadingCloseV2: false,
      loadingBundleStatus: false,
      loadingExcel: false,
      dialogSendCubage: false,
      sendCubageMode: "v1",
      cubicadorV2Enabled: config.cubicador_v2,
      optionsAmountFormatting: OPTIONS_AMOUNT_FORMATTING,
      dialogCopyToTemplate: false,
      dialogCreateTemplateFromCubage: false,
      dialogCopyFromTemplate: false,
      dialogShowInitialFillRequests: false,
      dialogUploadMaterialsExcelFromCubage: false,
      showCosts: false,
      //Data a mover a mixin
      proyectoSeleccionado: {},
      codigoProyecto: null,
      codigoLugarInstalacion: null,
      lugarInstalacion: {},
      rolModuloPermiso: {},
      // Closure of the cubicación 2 days after dispatch (ms-cubicador /document_closure)
      cubageClosure: null,
      // Saved v2 header (CubageDeliveryHeader): address, comuna, región, contact, date
      deliveryInfo: null,
      form: {
        sap_stage: null,
        desired_dispatch_date: null,
      },
    };
  },
  methods: {
    ...proyectoMethods,
    ...authMethods,
    ...mapActions({
      setDefaultCurrentCubage: "cubage/setDefaultCurrentCubage",
      setDefaultCubageMaterials: "cubage/setDefaultCubageMaterials",
      cleanInitialFillRequests: "cubage/cleanInitialFillRequests",
      getAllTypesMaterial: "cubage/getAllTypesMaterial",
      getCubageFromPlaceId: "cubage/getCubageFromPlaceId",
      getAllMaterials: "cubage/getAllMaterials",
      getCubageClosure: "cubage/getCubageClosure",
      loadBundleEditOptions: "cubage/loadBundleEditOptions",
      getAllUnits: "cubage/getAllUnits",
      getCubageMaterials: "cubage/getCubageMaterials",
      getCubageMaterialsExecution: "cubage/getCubageMaterialsExecution",
      getCubageBoardAttachments: "cubage/getCubageBoardAttachments",
      getCubageBoardPanels: "cubage/getCubageBoardPanels",
      sendDownloadExcelFromCubage: "cubage/downloadExcelFromCubage",
      getAllDispatchs: "cubage/getAllDispatchs",
      closeCubage: "cubage/closeCubage",
      closeCubageV2: "cubage/closeCubageV2",
      getCubageBundles: "cubage/getCubageBundles",
      getCubageOthersAttachments: "cubage/getCubageOthersAttachments",
      getTemplates: "cubageTemplate/getTemplates",
      getInitialFillRequestsFromPlace: "cubage/getInitialFillRequestsFromPlace",
      getProjectInfo: "project/getProjectInfo",
      resetCubage: "cubage/resetCubage",
      //SAP
      getStagesAvailableFromProject:
        "requestMaterialsSap/getStagesAvailableFromProject",
      resetCurrentSapCodes: "supplying/resetCurrentSapCodes",
    }),
    async getAllData() {
      await this.getProjectInfo({
        project_code: this.$route.query.sap_project,
      });
      await this.obtenerProyectoUsuario();
      this.codigoProyecto = this.$route.params.codigoProyecto;
      this.codigoLugarInstalacion = this.$route.params.codigoLugarInstalacion;
      this.lugarInstalacion = {
        codigo_lugar_instalacion: this.codigoLugarInstalacion,
        codigo_proyecto: this.codigoProyecto,
      };
      let permisos = permiso.obtenerPermisos(
        this.user,
        this.$router.currentRoute.name
      );
      this.rolModuloPermiso = permisos;
      this.loadingClose = true;
      await this.getCubageFromPlaceId({
        place_id: this.$route.query.sap_project
          ? this.$route.query.sap_project
          : this.codigoLugarInstalacion,
        user_id: this.user.email,
        is_sap: this.$route.query.sap_project ? true : undefined,
      });
      this.loadingClose = false;
      this.getAllTypesMaterial();
      this.getAllUnits();
      if (this.projectInfo?.business_unit?.sap_code) {
        this.getAllMaterials({
          page: 1,
          is_sap: this.$route.query.sap_project ? true : undefined,
          only_stock_materials:
            this.cubicadorV2Enabled && this.$route.query.sap_project ? true : undefined,
          standard_materials: true,
          business_unit: this.projectInfo?.business_unit?.sap_code,
        });
      }
      this.getAllDispatchs();

      //SAP
      if (this.$route.query.sap_project) {
        await this.getStagesAvailableFromProject({
          project_code: this.$route.query.sap_project,
        });
      }
    },
    openModalSendCubage() {
      this.sendCubageMode = "v1";
      this.dialogSendCubage = true;
    },
    async openModalSendCubageV2() {
      // Before approval the cubicación can be sent again: the new request replaces the one
      // still waiting (ms-cubicador cancels it in aprobación). After approval, changes go
      // in the cubicación table (applied to the SAP request).
      if (this.bundleIsPendingApproval) {
        const result = await this.$swal({
          icon: "question",
          title: "Ya hay una solicitud en aprobación",
          text: `Si envías la cubicación de nuevo, la solicitud ${getSliCode(
            this.latestCubageBundle
          )} se reemplaza por una nueva con los materiales actuales y se cancela su aprobación.`,
          showCancelButton: true,
          confirmButtonText: "Reemplazar",
          cancelButtonText: "Cancelar",
        });
        if (!result.isConfirmed) return;
      }
      const info = this.deliveryInfo || {};
      if (!info.address || !info.commune || !info.region) {
        return this.$swal({
          icon: "error",
          title: "Faltan datos de despacho",
          text: "Completa y guarda dirección, comuna y región antes de enviar la cubicación.",
        });
      }
      if (!this.form.desired_dispatch_date && info.desired_dispatch_date) {
        this.form.desired_dispatch_date = info.desired_dispatch_date;
      }
      this.sendCubageMode = "v2";
      this.dialogSendCubage = true;
    },
    closeModalSendCubage($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.dialogSendCubage = false;
      }
    },
    getSliCode,
    formatDateTime(isoValue) {
      return new Date(isoValue).toLocaleString("es-CL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async refreshCubageBundles() {
      // With v2 off there are no bundles to show, and ms-cubicador may not even expose
      // /get_document_bundles yet - skip the call so the banner never renders.
      if (!this.cubicadorV2Enabled) return;
      if (!this.currentCubage || !this.currentCubage.id) return;
      this.loadingBundleStatus = true;
      await this.getCubageBundles({ document_id: this.currentCubage.id });
      if (
        this.latestCubageBundle &&
        this.latestCubageBundle.status === CUBAGE_BUNDLE_STATUS.POSTED_TO_SAP
      ) {
        // SET_CUBAGE_MATERIALS is what actually recomputes currentCubage.isClosed
        // (true once any material has a non-null erp_status) - every tab (equipos,
        // materiales, ejecución, otros) already locks its own edit UI off that flag,
        // so refreshing materials here is what makes the whole cubicación lock once
        // the bundle posts to SAP, without touching each tab individually.
        await this.getCubageMaterials({ document_id: this.currentCubage.id });
        this.cubageClosure = await this.getCubageClosure({ document_id: this.currentCubage.id });
        // Which sent lines can still be changed from the table
        this.loadBundleEditOptions({ bundle_id: this.latestCubageBundle.id });
      } else {
        this.cubageClosure = null;
        this.loadBundleEditOptions(null);
      }
      this.loadingBundleStatus = false;
    },
    obtenerProyectoUsuario() {
      this.obtenerProyecto(this.$route.params.codigoProyecto)
        .then((res) => {
          this.proyectoSeleccionado = res.body;
        })
        .catch((error) => {});
    },
    openModalCopyToTemplate() {
      this.dialogCopyToTemplate = true;
    },
    closeModalCopyToTemplate($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.dialogCopyToTemplate = false;
      }
    },
    openModalCreateTemplateFromCubage() {
      this.dialogCreateTemplateFromCubage = true;
    },
    closeModalCreateTemplateFromCubage($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.dialogCreateTemplateFromCubage = false;
      }
    },
    openModalCopyFromTemplate() {
      this.dialogCopyFromTemplate = true;
    },
    closeModalCopyFromTemplate($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.dialogCopyFromTemplate = false;
      }
    },
    openModalShowInitialFillRequests() {
      this.dialogShowInitialFillRequests = true;
    },
    closeModalShowInitialFillRequests($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.dialogShowInitialFillRequests = false;
      }
    },
    openModalUploadMaterialsExcelFromCubage() {
      this.dialogUploadMaterialsExcelFromCubage = true;
    },
    closeModalUploadMaterialsExcelFromCubage() {
      this.dialogUploadMaterialsExcelFromCubage = false;
    },
    async downloadExcelFromCubage() {
      this.loadingExcel = true;
      const response = await this.sendDownloadExcelFromCubage({
        document_id: this.currentCubage.id,
      });
      let fileURL = window.URL.createObjectURL(new Blob([response]));
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `materiales_${this.lugarInstalacion.codigo_lugar_instalacion}.xlsx`
      );
      document.body.appendChild(fileLink);
      fileLink.click();
      this.loadingExcel = false;
    },
    async closeCurrentCubage(ignore_warnings = false) {
      if (
        this.$route.query.sap_project &&
        !this.form.sap_stage && !this.currentProjectIsOv
      ) {
        return this.$swal({
          icon: "error",
          title: "Error",
          text: "Debes seleccionar la etapa del proyecto",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      let self = this;
      this.closeModalSendCubage();
      this.loadingClose = true;
      const resp = await this.closeCubage({
        document_id: self.currentCubage.id,
        user: self.user.email,
        sap_stage: self.currentProjectIsOv
          ? DEFAULT_STAGE_PROJECT_OV_RESIDENTIAL
          : self.$route.query.sap_project
          ? this.form.sap_stage
          : undefined,
        ignore_warnings: !this.currentCubage.is_residential
          ? true
          : ignore_warnings,
      });
      if (!resp) {
        this.$swal({
          icon: "error",
          title: "Error",
          text:
            "Has excedido el numero máximo de intentos, prueba nuevamente mas tarde",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (resp && resp.status === 409) {
        this.closeModalSendCubage();
        this.loadingClose = false;
        let itemsPending = extractWordsUpperCase(resp.data.detail);
        //Mostrar el listado en un mensaje de alerta, que las etiquetas li se muestren cada una en una linea
        let html = `
          <p>La cubicación tiene materiales de los siguientes items de gasto faltantes:</p>
          <div class="my-4">
            ${itemsPending
              .map((item) => `<p class="pr-2 my-0">${item}</p>`)
              .join("")}
          </div>
          <small>Si deseas agregarlos presiona Cancelar, si deseas continuar igualmente presiona Aceptar</small>
        `;
        this.$swal({
          icon: "warning",
          title: "Atención",
          html,
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#2c81c0",
          cancelButtonColor: "#d9534f",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((result) => {
          if (result.value) {
            self.closeCurrentCubage(true);
          }
        });
      }
      if (!resp || resp.status === 500) {
        this.$swal({
          icon: "error",
          title: "Error",
          text:
            "Ha ocurrido un error en el servidor, por favor intenta nuevamente mas tarde",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (resp && resp.status === 200) {
        this.$swal({
          icon: "success",
          title: "Excelente",
          text: "Cubicación cerrada correctamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
        self.form.sap_stage = null;
        self.getCubageMaterials({
          document_id: self.currentCubage.id,
        });
        self.getInitialFillRequestsFromPlace({
          place_id: self.$route.query.sap_project
            ? self.$route.query.sap_project
            : self.codigoLugarInstalacion,
        });
        this.closeModalSendCubage();
      }
      if (resp && resp.status === 400) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      this.loadingClose = false;
    },
    async closeCurrentCubageV2(ignore_warnings = false, ignore_lead_time = false) {
      if (!this.form.desired_dispatch_date) {
        return this.$swal({
          icon: "error",
          title: "Error",
          text: "Debes seleccionar la fecha de despacho deseada",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (
        this.$route.query.sap_project &&
        !this.form.sap_stage &&
        !this.currentProjectIsOv
      ) {
        return this.$swal({
          icon: "error",
          title: "Error",
          text: "Debes seleccionar la etapa del proyecto",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      let self = this;
      this.closeModalSendCubage();
      this.loadingCloseV2 = true;
      const resp = await this.closeCubageV2({
        document_id: self.currentCubage.id,
        user: self.user.email,
        sap_stage: self.currentProjectIsOv
          ? DEFAULT_STAGE_PROJECT_OV_RESIDENTIAL
          : self.$route.query.sap_project
          ? this.form.sap_stage
          : undefined,
        ignore_warnings: !this.currentCubage.is_residential ? true : ignore_warnings,
        desired_dispatch_date: this.form.desired_dispatch_date,
        ignore_lead_time,
      });
      if (!resp) {
        this.$swal({
          icon: "error",
          title: "Error",
          text:
            "Has excedido el numero máximo de intentos, prueba nuevamente mas tarde",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (resp && resp.status === 200) {
        const dropped = resp.data.dropped_materials || [];
        this.$swal({
          icon: dropped.length ? "warning" : "success",
          title: "Excelente",
          text:
            `Solicitud de Materiales ${resp.data.sli_code || getSliCode({ id: resp.data.bundle_id })} enviada a aprobación` +
            (dropped.length
              ? `. No se incluyeron por no ser materiales de existencia (EXI-): ${dropped.join(", ")}`
              : ""),
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: dropped.length ? 8000 : 4000,
          timerProgressBar: true,
        });
        self.form.sap_stage = null;
        self.form.desired_dispatch_date = null;
        self.refreshCubageBundles();
      }
      if (resp && resp.status === 409 && resp.data.detail && resp.data.detail.type === "lead_time") {
        // Purchase lines that can't arrive by the desired dispatch date: confirm to continue
        this.$swal({
          icon: "warning",
          title: "Atención",
          width: 900,
          html: leadTimeWarningHtml(resp.data.detail),
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#2c81c0",
          cancelButtonColor: "#d9534f",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((result) => {
          if (result.value) {
            self.closeCurrentCubageV2(ignore_warnings, true);
          }
        });
      } else if (resp && resp.status === 409) {
        // Missing main equipment: same confirm-and-continue as the v1 send
        const itemsPending = extractWordsUpperCase(resp.data.detail);
        this.$swal({
          icon: "warning",
          title: "Falta equipo principal",
          html: `
            <p>La cubicación no tiene ningún material de estas categorías de equipo principal:</p>
            <div class="my-4">
              ${itemsPending.map((item) => `<p class="pr-2 my-0 font-weight-bold">${item}</p>`).join("")}
            </div>
            <small>Si faltan, vuelve y agrégalos. Si el proyecto no los necesita, puedes enviar la solicitud sin ellos.</small>
          `,
          confirmButtonText: "Enviar sin ellos",
          confirmButtonColor: "#2c81c0",
          cancelButtonColor: "#757575",
          cancelButtonText: "Volver y agregar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((result) => {
          if (result.value) {
            self.closeCurrentCubageV2(true, ignore_lead_time);
          }
        });
      }
      if (resp && resp.status === 400) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }
      if (resp && resp.status === 500) {
        this.$swal({
          icon: "error",
          title: "Error",
          text:
            "Ha ocurrido un error en el servidor, por favor intenta nuevamente mas tarde",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      this.loadingCloseV2 = false;
    },
    closeRemainingCurrentCubage() {
      let message = `¿ Deseas solicitar los materiales restantes ?, ten en cuenta que ${
        this.getCubageMaterialsWithoutCode.length
          ? `aun quedan <b>${this.getCubageMaterialsWithoutCode.length}</b> ${
              this.getCubageMaterialsWithoutCode.length > 1
                ? "materiales"
                : "material"
            } sin código que no se van a solicitar y solo`
          : ""
      } se enviarán los materiales que hayas reemplazado`;
      let self = this;
      this.$swal
        .fire({
          icon: "warning",
          title: message,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#d9534f",
          confirmButtonText: sendRemaining ? "Solicitar" : "Cerrar",
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loadingClose = true;
            const resp = await this.closeCubage({
              document_id: self.currentCubage.id,
              user: this.user.email,
              ignore_warnings: true,
            });
            if (!resp) {
              this.$swal({
                icon: "error",
                title: "Error",
                text:
                  "Has excedido el numero máximo de intentos, prueba nuevamente mas tarde ",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp && resp.status === 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: sendRemaining
                  ? "Materiales solicitados correctamente"
                  : "Cubicación cerrada correctamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              self.getCubageMaterials({
                document_id: self.currentCubage.id,
              });
              self.getInitialFillRequestsFromPlace({
                place_id: self.$route.query.sap_project
                  ? self.$route.query.sap_project
                  : self.codigoLugarInstalacion,
              });
            }
            if (!resp || resp.status === 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text:
                  "Ha ocurrido un error en el servidor, por favor intenta nuevamente mas tarde",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            this.loadingClose = false;
          }
        });
    },
    async resetCurrentCubage() {
      if (!this.canResetCubage) {
        return this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "La cubicación no puede ser reiniciada, ya está cerrada",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      let message = `¿ Deseas reiniciar esta cubicación y eliminar todos sus materiales ?. Ten en cuenta que esta acción no se puede deshacer.`;
      // v2: a request still waiting for approval is cancelled by the reset
      if (this.latestCubageBundle && this.latestCubageBundle.status === CUBAGE_BUNDLE_STATUS.PENDING_APPROVAL) {
        message += ` La solicitud ${getSliCode(this.latestCubageBundle)} que está en aprobación se cancelará.`;
      }
      // v2: a request already in SAP is annulled (its ST and SCs are closed), if nothing of it
      // has been picked or bought yet; ms-cubicador checks and says why otherwise
      if (this.latestCubageBundle && this.latestCubageBundle.status === CUBAGE_BUNDLE_STATUS.POSTED_TO_SAP) {
        message += ` La solicitud ${getSliCode(this.latestCubageBundle)} ya está en SAP: se anulará y se cerrarán su solicitud de traslado y sus solicitudes de compra. Solo es posible si nada se ha preparado ni comprado.`;
      }
      let self = this;
      this.$swal
        .fire({
          icon: "warning",
          title: message,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#d9534f",
          confirmButtonText: "Reiniciar",
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loadingClose = true;
            const resp = await this.resetCubage({
              document_id: self.$route.query.sap_project,
              user: this.user.email,
            });
            if (!resp) {
              this.$swal({
                icon: "error",
                title: "Error",
                text:
                  "Ha ocurrido un error en el servidor, por favor intenta nuevamente mas tarde",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp && resp.status === 200) {
              const cancelled = (resp.data && resp.data.cancelled_bundles) || [];
              const annulled = (resp.data && resp.data.cancelled_requests) || [];
              this.$swal({
                icon: "success",
                title: "Excelente",
                text:
                  "Cubicación reiniciada correctamente" +
                  (cancelled.length ? `. Se canceló la solicitud ${cancelled.join(", ")} que estaba en aprobación.` : "") +
                  (annulled.length ? `. Se anuló la solicitud ${annulled.join(", ")} y se cerraron sus documentos en SAP.` : ""),
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              self.getAllData();
            }
            if (!resp || resp.status >= 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                // e.g. 502 when SAP refused closing a document
                text:
                  (resp && resp.data && typeof resp.data.detail === "string" && resp.data.detail) ||
                  "Ha ocurrido un error en el servidor, por favor intenta nuevamente mas tarde",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            // e.g. 400 "ya tiene solicitudes de SAP asociadas": say why instead of doing nothing
            if (resp && resp.status >= 400 && resp.status < 500) {
              this.$swal({
                icon: "error",
                title: "No se pudo reiniciar",
                text: (resp.data && typeof resp.data.detail === "string" && resp.data.detail) || "No se pudo reiniciar la cubicación",
              });
            }
            this.loadingClose = false;
          }
        });
    },
  },
  computed: {
    ...proyectoComputed,
    ...authUsuarioComputed,
    ...mapGetters({
      currentCubage: "cubage/currentCubage",
      cubageMaterials: "cubage/cubageMaterials",
      availableStagesProjects: "requestMaterialsSap/availableStagesProjects",
      projectInfo: "project/projectInfo",
      projectInfoDetailAndTecnical: "project/projectInfoDetailAndTecnical",
      latestCubageBundle: "cubage/latestCubageBundle",
      canAddToSentRequest: "cubage/canAddToSentRequest",
    }),
    // Closed cubicaciones can't be reset, except v2 ones whose request is in SAP: ms-cubicador
    // annuls it if nothing has been picked or bought yet
    canResetCubage() {
      return Boolean(this.currentCubage) && (!this.currentCubage.isClosed || this.canAddToSentRequest);
    },
    // code -> { isMainEquipment, isStandard } for the request view's columns
    materialsInfo() {
      const businessUnit =
        this.projectInfo && this.projectInfo.business_unit ? this.projectInfo.business_unit.sap_code : null;
      const info = {};
      this.cubageMaterials.forEach(({ material }) => {
        if (material && material.code && material.code !== "-") {
          info[material.code] = {
            description: material.description,
            isMainEquipment: MAIN_EQUIPMENT_ITEM_GASTO.includes(material.item_gasto),
            isStandard: isStandardMaterial(material, businessUnit),
          };
        }
      });
      return info;
    },
    // The v2 send needs the "Datos de despacho" saved and complete
    deliveryComplete() {
      const info = this.deliveryInfo || {};
      return Boolean(info.address && info.commune && info.region && info.desired_dispatch_date);
    },
    // v2 flow on a SAP project: header + one "pedido completo" tab
    unifiedOrder() {
      return Boolean(this.cubicadorV2Enabled && this.$route.query.sap_project);
    },
    minDispatchDate() {
      return minDispatchIsoDate();
    },
    bundleIsPendingApproval() {
      return (
        this.latestCubageBundle &&
        this.latestCubageBundle.status === CUBAGE_BUNDLE_STATUS.PENDING_APPROVAL
      );
    },
    bundleStatusInfo() {
      if (!this.latestCubageBundle) return {};
      return (
        CUBAGE_BUNDLE_STATUS_LIST.find(
          (status) => status.id === this.latestCubageBundle.status
        ) || {}
      );
    },
    bundleAlertType() {
      return this.bundleStatusInfo.alertType || "info";
    },
    currentProjectIsOv() {
      return this.projectInfo && this.projectInfo.is_ov;
    },
    currentCubageIsIncomplete() {
      return (
        this.currentCubage &&
        this.currentCubage.isClosed &&
        this.cubageMaterials
          .filter(({ material }) => {
            return material.code !== "-";
          })
          .some((material) => material.erp_status === null)
      );
    },
    someCubageMaterialWithoutType() {
      return this.cubageMaterials.some((material) => {
        return material.type === null;
      });
    },
    getCubageMaterialsWithoutCode() {
      return this.cubageMaterials.filter(({ material }) => {
        return material.code === "-";
      });
    },
    cubageMaterialsIsSomeMaterialRemainingToClose() {
      return (
        this.cubageMaterials.some((material) => material.erp_status !== null) &&
        this.cubageMaterials.some(
          (material) =>
            material.material.code !== "-" && material.erp_status === null
        )
      );
    },
  },
  watch: {
    currentCubage: {
      immediate: true,
      handler: function(cubage) {
        if (cubage && cubage.id) {
          this.getCubageMaterials({
            document_id: cubage.id,
          });
          this.getCubageMaterialsExecution({
            document_id: cubage.id,
          });
          this.getCubageBoardAttachments({
            document_id: cubage.id,
          });
          this.getCubageOthersAttachments({
            document_id: cubage.id,
          });
          this.getCubageBoardPanels({
            document_id: cubage.id,
          });
          this.refreshCubageBundles();
        }
      },
    },
    cubageMaterials(materials) {
      if (
        materials.length &&
        materials.some((material) => material.erp_status !== null)
      ) {
        this.setSapCodesAndGetStatusRequests(
          materials
            .filter((item) => item.erp_status)
            .map((item) => ({
              ...item,
              sap_request_type: {
                name:
                  item.erp_status !== "OC"
                    ? Object.keys(TYPES_REQUESTS_SAP)[0]
                    : Object.keys(TYPES_REQUESTS_SAP)[1],
              },
              sap_number: item.solicitud_erp,
            }))
        );
      }
    },
  },
};
</script>

<style>
.transition-easy-out {
  transition: all 0.18s ease-in-out;
}
</style>